export { activityKindToLabel, activityKindToShortLabel } from "./activity-kind-to-label";
